var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.711,
    height: 24.542,
    viewBox: "0 0 24.711 24.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout",
    d: "M7.442,18.024v1.839a3.682,3.682,0,0,0,3.678,3.678h9.242a3.682,3.682,0,0,0,3.678-3.678V3.678A3.682,3.682,0,0,0,20.362,0H11.12A3.682,3.682,0,0,0,7.442,3.678V5.518a.92.92,0,1,0,1.839,0V3.678A1.841,1.841,0,0,1,11.12,1.839h9.242A1.841,1.841,0,0,1,22.2,3.678V19.863A1.841,1.841,0,0,1,20.362,21.7H11.12a1.841,1.841,0,0,1-1.839-1.839V18.024a.92.92,0,1,0-1.839,0Zm-6.27-7.833L3.232,8.132a.92.92,0,0,1,1.3,1.3L3.067,10.9H14.109a.92.92,0,0,1,0,1.839H3.067L4.532,14.2a.92.92,0,1,1-1.3,1.3L1.172,13.442A2.3,2.3,0,0,1,1.172,10.191Zm0,0",
    transform: "translate(0.171 0.5)",
    fill: "#0f445a",
    stroke: "#204358",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b92007e5aae051b09736ff72aa0d9410.svg";
export { ForwardRef as ReactComponent };